// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__aK-Ij","inner":"Form_inner__1tu-R","range":"Form_range__1WDGo","name":"Form_name__gjEWh","actions":"Form_actions__1HNZ6"};